import React from 'react';
import { STATUS_COLORS } from '../../../utils/constants';
import { getStatusLabel } from '../../../utils/helpers';
import styles from './StatusBadge.module.css';

const StatusBadge = ({ status }) => {
  const color = STATUS_COLORS[status] || '#999999';
  
  return (
    <span 
      className={styles.badge}
      style={{ 
        backgroundColor: `${color}20`,
        color: color,
        borderColor: color
      }}
    >
      {getStatusLabel(status)}
    </span>
  );
};

export default StatusBadge;